<template>
  <div class="gpuMetal">
    <div class="h-banner">
      <div class="container">
        <h1>GPU裸金属服务器</h1>
        <div class="row">
          <p class="col-sm-7">一款可弹性伸缩的GPU计算服务，计算性能与GPU物理机无差别，具有安全物理隔离的特点，分钟级的交付周期将提供给您实时的业务响应能力，在复杂计算领域性能卓越，满足用户在深度学习、云游戏、大数据分析等业务场景下的需求。</p>
        </div>
      </div>
    </div>
    <div class="session-1">
      <div class="container">
        <div class="content">
          <img class="thumb visible-lg-block" src="@/assets/images/service/r_product_images_02.png" alt="">
          <ul>
            <li>
              <img src="@/assets/images/service/r_product_iocn_01.png">
              <div class="info">
                <div class="title">极限性能计算</div>
                <p>与物理机无差别的计算性能，充分发挥GPU的性能，性能最佳。</p>
              </div>
            </li>
            <li>
              <img src="@/assets/images/service/r_product_iocn_02.png">
              <div class="info">
                <div class="title">物理隔离</div>
                <p>物理级的隔离，网格存储计算完全隔离，提供专属独占的服务。</p>
              </div>
            </li>
            <li>
              <img src="@/assets/images/service/r_product_iocn_03.png">
              <div class="info">
                <div class="title">快速交付</div>
                <p>即开即用，服务器自动初始化，分钟级交付，灵活应对扩容。</p>
              </div>
            </li>
            <li>
              <img src="@/assets/images/service/r_product_iocn_04.png">
              <div class="info">
                <div class="title">稳定可靠</div>
                <p>5A级机房条件，电力与网络充足，可确保稳定提供服务</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="session-2">
      <div class="container">
        <div>
          <div class="title">通用型</div>
          <p>最新一代GPU裸金属服务器，超高性价比</p>
          <div class="title-s">使用场景</div>
          <p>1  通用的AI训练推理，算力达100TFLOP</p>
          <p>2  渲染农场，快速调度按需使用，自动释放</p>
          <p>3  云游戏云端流化场景，高密度GPU并发路数高</p>
        </div>
        <div class="tag-list">
          <ul>
            <li>
              <span class="tag">CPU</span>
              <span class="text">32核心</span>
            </li>
            <li>
              <span class="tag">内存</span>
              <span class="text">128GB</span>
            </li>
            <li>
              <span class="tag">GPU</span>
              <span class="text">10张</span>
            </li>
            <li>
              <span class="tag">SSD</span>
              <span class="text">512GB</span>
            </li>
            <li>
              <span class="tag">带宽</span>
              <span class="text">25Gbps</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.h-banner{
  background: #282839;
  color: #fff;
  h1{
    font-size: 36px;
    font-weight: bold;
    margin-top: 70px;
  }
  p{
    font-size: 18px;
    color: #A2A2BB;
    margin-top: 20px;
    margin-bottom: 70px;
  }
}
.session-1{
  .content{
    display: flex;
    border-bottom: solid 1px #D5D5D5;
    padding-bottom: 65px;
    padding-top: 100px;
  }
  .thumb{
    width: 400px;
    flex: none;
  }
  ul{
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    background-color: $color-primary;
    li{
      display: flex;
      width: 50%;
      box-sizing: border-box;
      padding: 22px;
      &:nth-child(1){
        border-bottom: 1px solid #718FFF;
        border-right: 1px solid #718FFF;
      }
      &:nth-child(2){
        border-bottom: 1px solid #718FFF;
      }
      &:nth-child(3){
        border-right: 1px solid #718FFF;
      }
      img{
        flex: none;
        width: 80px;
        height: 80px;
      }
      .info{
        flex: 1;
        display: flex;
        flex-direction: column;
        color: #fff;
        margin-left: 20px;
        .title{
          font-size: 18px;
          font-weight: bold;
        }
        p{
          font-size: 14px;
          margin-top: 14px;
        }
      }
    }
  }
}
@media (max-width: $screen-sm-min) {
  .session-1{
    .content{
      padding-top: 40px;
      padding-bottom: 0;
    }
    ul{
      display: block;
      li{
        width: 100%;
        border-bottom: 1px solid #718FFF;
      }
    }
  }
}
.session-2{
  .container{
    padding-bottom: 120px;
    .title{
      font-size: 24px;
      font-weight: bold;
      margin-top: 40px;
    }
    .title-s{
      font-size: 14px;
      font-weight: bold;
      margin-top: 20px;
    }
    p{
      font-size: 14px;
      margin-top: 10px;
    }
    .tag-list{
      margin-top: 20px;
      li{
        display: inline-block;
        margin-right: 60px;
        line-height: 40px;
        .tag{
          display: inline-block;
          color: $color-primary;
          padding: 0 18px;
          border-radius: 8px;
          font-weight: bold;
          font-size: 16px;
          border: 1px solid #979797;
          margin-top: 20px;
        }
        .text{
          display: inline-block;
          font-size: 24px;
          font-weight: bold;
          margin-left: 20px;
        }
      }
    }
  }
}
@media (max-width: $screen-sm-min) {
  .session-2{
    .container{
      padding-bottom: 40px;
    }
  }
}
</style>
